module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA0ElEQVQ4T6WTMQrCQBBF3wfPIAgew9LKwto0XkFs1ZOIBxBbC20t1UrQUyiInkCw+LKQQIgbCMl2szv7/58/M7LdAdbAAGhROJJUvMvHsn0AhmVJVQC+KfMTuEQUJLbbkt4xkqDA6cNeUhJLsr0FjpJWfwQVAXbAKPVqKumTAVVVkAGEf1cgkfQIQRTAdh/o5uTOgV4ufgFjSacygDxjWYOC+bOmAIu6JYSWhhKOdUy8pSbeS00sFm0782QDTOq0MQzSWdIyNkiNR7nxMjVa5x/tHY7lY5rs/gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/logout.png
// module id = R+99
// module chunks = 1